module.exports = __webpack_public_path__ + "static/media/machine-placeholder.e9bb30e2.svg";